import { render } from "./notificationSettingsPopup.vue?vue&type=template&id=55fd10ee&scoped=true"
import script from "./notificationSettingsPopup.vue?vue&type=script&lang=js"
export * from "./notificationSettingsPopup.vue?vue&type=script&lang=js"

import "./notificationSettingsPopup.vue?vue&type=style&index=0&id=55fd10ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fd10ee"]])

export default __exports__